@if (order && form) {
    <form [formGroup]="form">
        <card-component>
            <card-title title="Create Mandate for order #{{ order.id }}"></card-title>
            <card-content>
                <div [ngStyle]="{ marginBottom: '16px' }">
                    <slide-toggle
                        [form]="form"
                        formControlName="include_initial_payment"
                        innerText="Include Initial Payment"
                    ></slide-toggle>
                    @if (form.value.include_initial_payment) {
                        <text-input
                            [form]="form"
                            formControlName="initial_payment"
                            [prefix]="systemConfigService.config.currency.symbol"
                            placeHolder="Initial Payment Total"
                            [error]="formErrors.initial_payment"
                        ></text-input>
                    }
                </div>
                <div [ngStyle]="{ marginBottom: '16px' }">
                    <table class="table table-hover" [ngStyle]="{ width: '100%' }">
                        <tbody>
                            <tr>
                                <td>Total</td>
                                <td>
                                    <base-currency-component
                                        [value]="order.total"
                                        [currency]="order.currency"
                                        [precision]="order.currency_precision"
                                        [locale]="systemConfigService.config.locale"
                                    ></base-currency-component>
                                </td>
                            </tr>
                            <tr>
                                <td>Initial Payment</td>
                                <td>
                                    <base-currency-component
                                        [value]="initialPaymentRaw"
                                        [currency]="order.currency"
                                        [precision]="order.currency_precision"
                                        [locale]="systemConfigService.config.locale"
                                    ></base-currency-component>
                                </td>
                            </tr>
                            <tr>
                                <td>Remaining for plan</td>
                                <td>
                                    <base-currency-component
                                        [value]="order.total - initialPaymentRaw"
                                        [currency]="order.currency"
                                        [precision]="order.currency_precision"
                                        [locale]="systemConfigService.config.locale"
                                    ></base-currency-component>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <raised-button (click)="createMandate()" [disabled]="loading" color="primary" [styles]="{ width: '100%' }">Create Mandate</raised-button>
                </div>
            </card-content>
        </card-component>
    </form>
}
